var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
var defaultSortParam = '';
var defaultSortDirection = '';
var TramitadorFilterService = /** @class */ (function (_super) {
    __extends(TramitadorFilterService, _super);
    function TramitadorFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TramitadorFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        /*clean hours*/
        filter.fechaInicio.setHours(0, 0, 0);
        filter.fechaFin.setHours(23, 59, 59);
        return new HttpParams()
            .append('fechaInicio', filter.fechaInicio.toJSON())
            .append('fechaFin', filter.fechaFin.toJSON())
            .append('tipos', JSON.stringify(filter.tipos))
            .append('legislaciones', JSON.stringify(filter.legislaciones))
            .append('origen', filter.origen.toString())
            .append('matriculasExtrangeras', this.getTristateValue(filter.matriculasExtrangeras))
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    TramitadorFilterService.prototype.createParamsFromSelectedItems = function (selectedItems) {
        return new HttpParams().append('listaId', JSON.stringify(selectedItems));
    };
    TramitadorFilterService.prototype.getTristateValue = function (value) {
        if (value === null) {
            return '';
        }
        else {
            return value.toString();
        }
    };
    return TramitadorFilterService;
}(CustomFilterService));
export { TramitadorFilterService };
